module.exports = __webpack_public_path__ + "static/media/ch.c5973ba2.svg";